import { useState } from "react";

export function useAIChat() {
  const [question, setQuestion] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleAsk = async () => {
    if (!question.trim()) return;
    
    const userMessage = question.trim();
    setQuestion(""); // Clear input immediately
    
    // Add user message to history
    const newUserMessage = { role: "user", content: userMessage };
    const updatedMessages = [...messages, newUserMessage];
    setMessages(updatedMessages);
    
    setLoading(true);
    
    try {
      // Send the full conversation history including the new user message
      const conversationHistory = updatedMessages;
      console.log("[AIChat] Sending request to /api/chat with conversation history:", conversationHistory.length, "messages");
      console.log("[AIChat] Conversation history:", conversationHistory.map(m => ({ role: m.role, content: m.content.substring(0, 50) + "..." })));
      const res = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          question: userMessage,
          messages: conversationHistory
        }),
      });
      
      console.log("[AIChat] Response status:", res.status, res.statusText);
      
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        const errorMsg = errorData.error || `Server error: ${res.status} ${res.statusText}`;
        console.error("[AIChat] Server error:", errorMsg, errorData);
        throw new Error(errorMsg);
      }
      
      const data = await res.json();
      console.log("[AIChat] Success - received answer, length:", data.answer?.length || 0);
      
      // Provide more helpful error messages
      let answer = data.answer ?? "No answer.";
      if (answer.includes("Failed to fetch") || answer.includes("NetworkError")) {
        answer = "Cannot connect to server. Please make sure the server is running on port 5000.";
      }
      
      // Add AI response to history
      const newAiMessage = { role: "assistant", content: answer };
      setMessages(prev => [...prev, newAiMessage]);
    } catch (err) {
      console.error("[AIChat] Error details:", {
        message: err.message,
        name: err.name,
        stack: err.stack
      });
      
      // Provide more helpful error messages
      let errorMessage = err.message;
      if (err.message.includes("Failed to fetch") || err.message.includes("NetworkError")) {
        errorMessage = "Cannot connect to server. Please make sure the server is running on port 5000.";
      } else if (err.message.includes("500")) {
        errorMessage = err.message || "Server error. Please check the server logs for details.";
      }
      
      // Add error message to history
      const errorAiMessage = { 
        role: "assistant", 
        content: errorMessage || "Sorry, something went wrong. Please check if the server is running and try again." 
      };
      setMessages(prev => [...prev, errorAiMessage]);
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setQuestion("");
    setMessages([]);
    setLoading(false);
  };

  return {
    question,
    setQuestion,
    messages,
    loading,
    handleAsk,
    reset
  };
}
